var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLoading
      ? _c("div", { staticClass: "wrap-title-component" }, [
          _vm._v("\n    " + _vm._s(_vm.titleComponent) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c("h5", { staticClass: "mb-2" }, [
          _vm._v("\n    " + _vm._s(_vm.titleView) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c(
          "div",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    attrs: { cols: _vm.detailComponent.is_pagescreen ? 8 : 12 }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrap-field no-gutters" },
                      _vm._l(_vm.detailComponent.columns, function(column) {
                        return _c(
                          "div",
                          {
                            key: column.field_ui_key,
                            class:
                              "col-md-" +
                              (column.grid_size ? column.grid_size : 12),
                            staticStyle: { "padding-right": "10px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "field-list dummy hover-none",
                                staticStyle: { cursor: "default" }
                              },
                              [
                                _c("p", { staticClass: "column-name" }, [
                                  _vm._v(_vm._s(column.name))
                                ]),
                                _vm._v(" "),
                                _c("field-preview", {
                                  attrs: {
                                    column: column,
                                    "use-drag-icon": false
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      })
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.detailComponent.is_pagescreen && _vm.type !== "create"
                  ? _c(
                      "b-col",
                      { attrs: { cols: "4" } },
                      [
                        _c("h5", [_vm._v("Action Button")]),
                        _vm._v(" "),
                        _vm._l(_vm.detailComponent.action_buttons, function(
                          button
                        ) {
                          return _c(
                            "div",
                            {
                              key: button.key,
                              staticClass: "action-button-list hover-none"
                            },
                            [
                              _c("i", {
                                class:
                                  "icon-button fa " +
                                  (button.icon_web.includes("fa-")
                                    ? button.icon_web
                                    : "fa-" + button.icon_web)
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(button.label) +
                                  "\n        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      : _c("div", { staticClass: "skeleton-component" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a8f6fd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a8f6fd3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyCreateDetailView.vue
// module id = null
// module chunks = 